// src/utils/selectRandomImages.ts
import { 
    ColorImages, 
    GeometrieFormes, 
    ObjetsCategories, 
    ImageType, 
    selectImagesCatalogLegacy,
    GeometrieSpecificite,
    ObjetsSpecificite
} from './selectImagesCatalog';

function getRandomElements<T>(arr: T[], count: number): T[] {
    const shuffled = arr.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
}

// Interface pour l'ancienne méthode
interface LegacySelectParams {
    type: ImageType[], 
    specificite: (GeometrieSpecificite | ObjetsSpecificite)[], 
    couleurInclude: ColorImages[], 
    couleurExclude: ColorImages[], 
    description: (GeometrieFormes | ObjetsCategories)[]
}

// Interface pour la nouvelle méthode avec catalogue direct
interface CatalogSelectParams {
    catalog: { [key: string]: string };
    count?: number;
}

// Type union pour les paramètres
type SelectRandomImagesParams = LegacySelectParams | CatalogSelectParams;

function isLegacyParams(params: SelectRandomImagesParams): params is LegacySelectParams {
    return 'type' in params;
}

export function selectRandomImages(params: SelectRandomImagesParams): string[] {
    let images: { [key: string]: string };
    let count = 10; // Valeur par défaut
    
    if (isLegacyParams(params)) {
        // Ancienne méthode avec paramètres séparés
        images = selectImagesCatalogLegacy(
            params.type, 
            params.specificite, 
            params.couleurInclude, 
            params.couleurExclude, 
            params.description
        );
    } else {
        // Nouvelle méthode avec catalogue direct
        images = params.catalog;
        if (params.count) {
            count = params.count;
        }
    }
    
    return getRandomElements(Object.keys(images), count).map(image => images[image]);
}
